import { getCompletedUploads } from '@wix/da-shared-react/pkg/redux/uploads/selectors';
import { getDataEntitiesByIds } from '@wix/da-shared-react/pkg/redux/entities/selectors';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { AppState, CompletedUploadWithDeviation, StudioSection } from '../../types/store';
import { STUDIO_UPLOADS_NAMESPACE } from '../../../constants';
import { getActiveSection, getStudioParams } from './page';

export function getCompletedUploadsWithDeviation(state: AppState): CompletedUploadWithDeviation[] {
  const completedUploads = getCompletedUploads(state).filter(
    fu => fu.tag === STUDIO_UPLOADS_NAMESPACE
  );
  const deviationIds = completedUploads
    .map(({ deviationId }) => deviationId)
    .filter((id): id is number => id != null);
  const deviations = getDataEntitiesByIds(state, deviationSchema, deviationIds).reduce(
    (acc, deviation) => ({ ...acc, [deviation.deviationId]: deviation }),
    {}
  );

  return completedUploads.map(({ deviationId, ...rest }) => ({
    ...rest,
    deviationId,
    deviation: deviationId && deviations[deviationId],
  }));
}

export function getIsUploadPage(state: AppState) {
  // we check that params are null to keep out the current stash folder page,
  // where you can select a group of deviations or folders and view them on studio via qs params.
  const params = getStudioParams(state);
  const isStudioRoot = !params.deviationIds && !params.folderIds;
  const sectionsAllowingUpload = [StudioSection.DRAFTS, StudioSection.STASH];

  return isStudioRoot && sectionsAllowingUpload.includes(getActiveSection(state));
}
